var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c(
        "el-container",
        [
          _c(
            "el-header",
            { attrs: { height: "42px" } },
            [
              _vm.viewMode == "list"
                ? _c("span", { staticClass: "ik-list-title" }, [
                    _c(
                      "span",
                      { staticClass: "svg-container ik-list-icon" },
                      [_c("svg-icon", { attrs: { "icon-class": "database" } })],
                      1
                    ),
                    _c("span", [_vm._v("数据列表")]),
                  ])
                : _vm._e(),
              _vm.viewMode === "list"
                ? _c(
                    "el-button-group",
                    { staticClass: "ik-list-menu" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.listCreateBtn },
                        },
                        [_vm._v("新增")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.listUpdateBtn },
                        },
                        [_vm._v("修改")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.listDetailsBtn },
                        },
                        [_vm._v("详情")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.listDeleteBtn },
                        },
                        [_vm._v("删除")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.viewMode === "info"
                ? _c(
                    "el-button-group",
                    { staticClass: "ik-list-menu" },
                    [
                      _vm.mode == "edit" || _vm.mode == "details"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoCreateBtn },
                            },
                            [_vm._v("新增")]
                          )
                        : _vm._e(),
                      _vm.mode == "details"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoUpdateBtn },
                            },
                            [_vm._v("修改")]
                          )
                        : _vm._e(),
                      _vm.mode == "edit" || _vm.mode == "details"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoCopyBtn },
                            },
                            [_vm._v("复制")]
                          )
                        : _vm._e(),
                      _vm.mode == "edit"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoDetailsBtn },
                            },
                            [_vm._v("详情")]
                          )
                        : _vm._e(),
                      _vm.mode == "add" || _vm.mode == "edit"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoSaveBtn },
                            },
                            [_vm._v("保存")]
                          )
                        : _vm._e(),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.infoCancelBtn },
                        },
                        [_vm._v("取消")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-main",
            [
              _vm.viewMode == "info"
                ? _c(
                    "el-form",
                    {
                      staticClass: "ik-info-head",
                      attrs: {
                        id: "ik-info-head",
                        inline: true,
                        "label-width": "120px",
                        disabled: _vm.mode == "details",
                      },
                      on: { validate: _vm.validate },
                      model: {
                        value: _vm.data.head,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "head", $$v)
                        },
                        expression: "data.head",
                      },
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-data-popup", {
                                ref: "input_userCode",
                                attrs: {
                                  url: "base/user/user/user/find/findPagination",
                                  "filed-list": [
                                    { code: "code", name: "编码" },
                                    { code: "name", name: "名称" },
                                  ],
                                  "search-key": "name",
                                  searcher: {},
                                  code: "userCode",
                                  name: "用户编码",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                  require: true,
                                },
                                on: {
                                  onFieldChange: _vm.onFieldChange,
                                  onPopupClick: _vm.headPopupClick,
                                },
                                model: {
                                  value: _vm.data.head["userCode"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "userCode", $$v)
                                  },
                                  expression: "data.head['userCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_userName",
                                attrs: {
                                  code: "userName",
                                  name: "用户名称",
                                  "default-value": "",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["userName"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "userName", $$v)
                                  },
                                  expression: "data.head['userName']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-select", {
                                ref: "input_typeSign",
                                attrs: {
                                  code: "typeSign",
                                  name: "类型标识",
                                  "default-value": "",
                                  "key-field": "key",
                                  "value-field": "value",
                                  options: _vm.toJson(_vm.jsonStr.typeSign),
                                  disabled: false,
                                },
                                model: {
                                  value: _vm.searcher["typeSign"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searcher, "typeSign", $$v)
                                  },
                                  expression: "searcher['typeSign']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-data-popup", {
                                ref: "input_motionCode",
                                attrs: {
                                  url: "health/content/content/motion/find/findPagination",
                                  "filed-list": [
                                    { code: "code", name: "编码" },
                                    { code: "name", name: "名称" },
                                  ],
                                  "search-key": "name",
                                  searcher: {},
                                  code: "motionCode",
                                  name: "运动项目编码",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                  require: true,
                                },
                                on: {
                                  onFieldChange: _vm.onFieldChange,
                                  onPopupClick: _vm.headPopupClick,
                                },
                                model: {
                                  value: _vm.data.head["motionCode"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "motionCode", $$v)
                                  },
                                  expression: "data.head['motionCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_motionName",
                                attrs: {
                                  code: "motionName",
                                  name: "运动项目名称",
                                  "default-value": "",
                                  edit: false,
                                  disabled: "",
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["motionName"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "motionName", $$v)
                                  },
                                  expression: "data.head['motionName']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-data-popup", {
                                ref: "input_motionVideoCode",
                                attrs: {
                                  url: "health/content/content/motionvideo/find/findPagination",
                                  "filed-list": [
                                    { code: "id", name: "ID" },
                                    { code: "code", name: "编码" },
                                    { code: "name", name: "名称" },
                                  ],
                                  "search-key": "name",
                                  searcher: {},
                                  code: "motionVideoCode",
                                  name: "打卡视频编码",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                  require: true,
                                },
                                on: {
                                  onFieldChange: _vm.onFieldChange,
                                  onPopupClick: _vm.headPopupClick,
                                },
                                model: {
                                  value: _vm.data.head["motionVideoCode"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "motionVideoCode",
                                      $$v
                                    )
                                  },
                                  expression: "data.head['motionVideoCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_motionVideoName",
                                attrs: {
                                  code: "motionVideoName",
                                  name: "打卡视频名称",
                                  "default-value": "",
                                  edit: false,
                                  disabled: "",
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["motionVideoName"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "motionVideoName",
                                      $$v
                                    )
                                  },
                                  expression: "data.head['motionVideoName']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("IkFormDate", {
                                ref: "input_recordDate",
                                attrs: {
                                  code: "recordDate",
                                  name: "记录日期",
                                  "default-value": "",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["recordDate"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "recordDate", $$v)
                                  },
                                  expression: "data.head['recordDate']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("IkFormDatetime", {
                                ref: "input_recordTime",
                                attrs: {
                                  code: "recordTime",
                                  name: "记录时间",
                                  "default-value": "",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["recordTime"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "recordTime", $$v)
                                  },
                                  expression: "data.head['recordTime']",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "querybg" },
                [
                  _vm.viewMode == "list"
                    ? _c(
                        "el-collapse",
                        {
                          staticClass: "ik-list-searcher",
                          attrs: { accordion: "" },
                          model: {
                            value: _vm.searcherActive,
                            callback: function ($$v) {
                              _vm.searcherActive = $$v
                            },
                            expression: "searcherActive",
                          },
                        },
                        [
                          _c(
                            "el-collapse-item",
                            {
                              staticClass: "ik-list-searcher-item",
                              attrs: { title: "", name: "1" },
                            },
                            [
                              _c("template", { slot: "title" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "ik-list-searcher-item-titles",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "svg-container ik-list-icon",
                                      },
                                      [
                                        _c("svg-icon", {
                                          attrs: { "icon-class": "search" },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" 查询条件 "),
                                  ]
                                ),
                              ]),
                              _c(
                                "el-form",
                                {
                                  staticClass: "ik-info-head",
                                  attrs: {
                                    id: "ik-info-head",
                                    inline: true,
                                    "label-width": "120px",
                                    disabled: false,
                                  },
                                  model: {
                                    value: _vm.searcher,
                                    callback: function ($$v) {
                                      _vm.searcher = $$v
                                    },
                                    expression: "searcher",
                                  },
                                },
                                [
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_userCode",
                                            attrs: {
                                              code: "userCode",
                                              name: "用户编码",
                                              "default-value": "",
                                              edit: false,
                                            },
                                            model: {
                                              value: _vm.searcher["userCode"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "userCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['userCode']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_userName",
                                            attrs: {
                                              code: "userName",
                                              name: "用户名称",
                                              "default-value": "",
                                              edit: false,
                                            },
                                            model: {
                                              value: _vm.searcher["userName"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "userName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['userName']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_typeSign",
                                            attrs: {
                                              code: "typeSign",
                                              name: "类型标识",
                                              "default-value": "1",
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.typeSign
                                              ),
                                              edit: false,
                                            },
                                            model: {
                                              value: _vm.searcher["typeSign"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "typeSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['typeSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_motionCode",
                                            attrs: {
                                              code: "motionCode",
                                              name: "运动项目编码",
                                              "default-value": "",
                                              edit: false,
                                            },
                                            model: {
                                              value: _vm.searcher["motionCode"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "motionCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['motionCode']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_motionName",
                                            attrs: {
                                              code: "motionName",
                                              name: "运动项目名称",
                                              "default-value": "",
                                              edit: false,
                                            },
                                            model: {
                                              value: _vm.searcher["motionName"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "motionName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['motionName']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_motionVideoName",
                                            attrs: {
                                              code: "motionVideoName",
                                              name: "打卡视频编码",
                                              "default-value": "",
                                              edit: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["motionVideoName"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "motionVideoName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['motionVideoName']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_motionVideoName",
                                            attrs: {
                                              code: "motionVideoName",
                                              name: "打卡视频名称",
                                              "default-value": "",
                                              edit: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["motionVideoName"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "motionVideoName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['motionVideoName']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("IkFormDate", {
                                            ref: "input_minRecordDate",
                                            attrs: {
                                              code: "minRecordDate",
                                              name: "最早记录日期",
                                              "default-value": "",
                                              edit: false,
                                            },
                                            on: {
                                              onFieldChange: _vm.onFieldChange,
                                            },
                                            model: {
                                              value:
                                                _vm.data.head["minRecordDate"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.data.head,
                                                  "minRecordDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "data.head['minRecordDate']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("IkFormDate", {
                                            ref: "input_maxRecordDate",
                                            attrs: {
                                              code: "maxRecordDate",
                                              name: "最晚记录日期",
                                              "default-value": "",
                                              edit: false,
                                            },
                                            on: {
                                              onFieldChange: _vm.onFieldChange,
                                            },
                                            model: {
                                              value:
                                                _vm.data.head["maxRecordDate"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.data.head,
                                                  "maxRecordDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "data.head['maxRecordDate']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("IkFormDatetime", {
                                            ref: "input_minRecordStartTime",
                                            attrs: {
                                              code: "minRecordStartTime",
                                              name: "最早记录开始时间",
                                              "default-value": "",
                                              edit: false,
                                            },
                                            on: {
                                              onFieldChange: _vm.onFieldChange,
                                            },
                                            model: {
                                              value:
                                                _vm.data.head[
                                                  "minRecordStartTime"
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.data.head,
                                                  "minRecordStartTime",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "data.head['minRecordStartTime']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("IkFormDatetime", {
                                            ref: "input_minRecordTime",
                                            attrs: {
                                              code: "minRecordTime",
                                              name: "最早记录时间",
                                              "default-value": "",
                                              edit: false,
                                            },
                                            on: {
                                              onFieldChange: _vm.onFieldChange,
                                            },
                                            model: {
                                              value:
                                                _vm.data.head["minRecordTime"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.data.head,
                                                  "minRecordTime",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "data.head['minRecordTime']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("IkFormDatetime", {
                                            ref: "input_maxRecordTime",
                                            attrs: {
                                              code: "maxRecordTime",
                                              name: "最晚记录时间",
                                              "default-value": "",
                                              edit: false,
                                            },
                                            on: {
                                              onFieldChange: _vm.onFieldChange,
                                            },
                                            model: {
                                              value:
                                                _vm.data.head["maxRecordTime"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.data.head,
                                                  "maxRecordTime",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "data.head['maxRecordTime']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "query-class" }, [
                                _c(
                                  "div",
                                  { staticClass: "query-btn-warp" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                        },
                                        on: { click: _vm.searchBtn },
                                      },
                                      [_vm._v("查询")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                        },
                                        on: { click: _vm.resetBtn },
                                      },
                                      [_vm._v("重置")]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.viewMode == "list"
                ? _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.listLoading,
                          expression: "listLoading",
                        },
                      ],
                      ref: "table",
                      staticClass: "ik-list-table",
                      attrs: {
                        data: _vm.tableData,
                        "element-loading-text": "加载中...",
                        stripe: true,
                        border: true,
                        fit: true,
                        height: "calc(100% - 50px)",
                        "header-row-class-name": "ik-list-table-header-row",
                        "header-cell-class-name": "ik-list-table-header-cell",
                        "row-class-name": "ik-list-table-body-row",
                        "cell-class-name": "ik-list-table-body-cell",
                        "highlight-current-row": true,
                      },
                      on: { "row-click": _vm.rowClick },
                    },
                    [
                      _c("ik-column-text", {
                        attrs: {
                          code: "userCode",
                          name: "用户编码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "userName",
                          name: "用户名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "typeSign",
                          name: "类型标识",
                          edit: false,
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.typeSign),
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "motionCode",
                          name: "运动项目编码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "motionName",
                          name: "运动项目名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "motionVideoCode",
                          name: "打卡视频编码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "motionVideoName",
                          name: "打卡视频名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-date", {
                        attrs: {
                          code: "recordDate",
                          name: "记录日期",
                          edit: false,
                        },
                      }),
                      _c("ik-column-datetime", {
                        attrs: {
                          code: "recordTime",
                          name: "记录时间",
                          edit: false,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-footer",
            { attrs: { height: "40px" } },
            [
              _vm.viewMode == "list"
                ? _c("ik-pagination", {
                    ref: "ik_list_pagination",
                    attrs: {
                      "page-no": _vm.pagination.pageNo,
                      "page-size": _vm.pagination.pageSize,
                      "total-count": _vm.pagination.totalCount,
                    },
                    on: { pageChangeMethod: _vm.pageChange },
                  })
                : _c(
                    "el-row",
                    { staticClass: "ik-list-pagination", attrs: { gutter: 0 } },
                    [
                      _c(
                        "el-col",
                        {
                          staticClass: "ik-list-enterprise-info",
                          attrs: { span: 6, offset: 12 },
                        },
                        [
                          _c("span", { staticStyle: { float: "left" } }, [
                            _vm._v(" 导萃门诊管理系统 "),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }